// src/ConsumerApp/Screens/Account/views/SupportView.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../../../assets/theme/theme';

import Headset from '../../../../assets/icons/Headset.svg';
import PhoneCall from '../../../../assets/icons/Phone.svg';
import WhatsappLogo from '../../../../assets/icons/WhatsappLogo.svg';
import EnvelopeSimple from '../../../../assets/icons/EnvelopeSimple.svg';
import CaretDown from '../../../../assets/icons/CaretDown.svg';
import ArrowLeft from '../../../../assets/icons/ArrowLeft.svg';

const FAQ_DATA = [
  {
    id: '1',
    question: 'How does Instant Buy delivery work?',
    answer:
      'Instant Buy items are priced at a fixed rate and delivered within 30–90 minutes inside serviceable pin codes directly to your site.',
  },
  {
    id: '2',
    question: 'What is an RFQ and how is it different from Instant Buy?',
    answer:
      'An RFQ (Request for Quote) allows you to request customized commercial pricing for bulk material orders exceeding standard retail quantities directly from supplier hubs.',
  },
  {
    id: '3',
    question: 'When do I need to make a NEFT payment?',
    answer:
      'NEFT/RTGS payment is recommended for large procurement orders exceeding standard UPI/card transaction limits (typically above ₹1,00,000).',
  },
  {
    id: '4',
    question: 'How do refunds work?',
    answer:
      'Refunds are processed back to your Brickbucket Wallet or original source account within 3–5 business days after material inspection and dispatch reconciliation.',
  },
  {
    id: '5',
    question: 'What is a project quote inside Configurator?',
    answer:
      'It automatically computes estimated material quantities, wastage buffers, and itemized costs based on your site floor plans and specification parameters.',
  },
];

export default function SupportView() {
  const navigate = useNavigate();
  const [openFaqId, setOpenFaqId] = useState('1');

  const toggleFaq = (id) => {
    setOpenFaqId((prev) => (prev === id ? null : id));
  };

  return (
    <div>
      <style>{`
        .bb-sub-circle-back-btn {
          width: 40px;
          height: 40px;
          border-radius: 999px;
          border: 1px solid #E8E0D0;
          background-color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-shrink: 0;
          padding: 0;
          margin-right: 12px;
          outline: none;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
          transition: transform 0.12s ease, background-color 0.12s ease;
          box-sizing: border-box;
        }
        .bb-sub-circle-back-btn:active {
          transform: scale(0.92);
          background-color: #F8FAFC;
        }
        .bb-sub-circle-back-btn img {
          width: 20px;
          height: 20px;
          display: block;
        }
        .bb-sub-mobile-header {
          display: none;
        }
        .bb-sub-desktop-header {
          display: flex;
        }
        @media (max-width: 900px) {
          .bb-sub-desktop-header {
            display: none !important;
          }
          .bb-sub-mobile-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 56px;
            padding: 0 16px;
            background-color: #FFFFFF;
            border-bottom: 1px solid #F1F5F9;
            box-sizing: border-box;
            position: sticky;
            top: 0;
            z-index: 1000;
          }
          .bb-sub-mobile-content {
            padding: 14px 16px 36px 16px !important;
          }
        }
      `}</style>

      {/* Mobile Edge-to-Edge Bar */}
      <div className="bb-sub-mobile-header">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            type="button"
            className="bb-sub-circle-back-btn"
            onClick={() => navigate('/consumer/account', { replace: true })}
            aria-label="Back to Account"
          >
            <img src={ArrowLeft} alt="Back" />
          </button>
          <h2 style={{
            fontFamily: theme.typography.headingLG.fontFamily,
            fontSize: 18,
            fontWeight: '800',
            color: theme.colors.charcoal,
            margin: 0,
          }}>
            Help & Support
          </h2>
        </div>
      </div>

      <div style={styles.container} className="bb-sub-mobile-content">
        {/* Desktop Header */}
        <div style={styles.pageHeader} className="bb-sub-desktop-header">
          <div>
            <h2 style={styles.headerTitle}>Help & Support</h2>
            <span style={styles.headerSubtitle}>
              Have any questions? Talk to our procurement specialists
            </span>
          </div>
        </div>

        <div style={styles.contactGrid}>
          <div style={styles.contactCard}>
            <div style={styles.contactIconCircleRed}>
              <img src={PhoneCall} alt="phone" style={styles.contactIconImg} />
            </div>
            <div style={styles.contactInfo}>
              <strong style={styles.contactTitle}>Customer Helpline</strong>
              <span style={styles.contactMeta}>Mon - Sat · 9:00 AM to 7:00 PM</span>
              <a href="tel:18001234567" style={styles.contactActionLinkRed}>
                +91 1800 123 4567
              </a>
            </div>
          </div>

          <div style={styles.contactCard}>
            <div style={styles.contactIconCircleGreen}>
              <img src={WhatsappLogo} alt="whatsapp" style={styles.contactIconImg} />
            </div>
            <div style={styles.contactInfo}>
              <strong style={styles.contactTitle}>WhatsApp Support</strong>
              <span style={styles.contactMeta}>Instant query handling for site dispatches</span>
              <a
                href="https://wa.me/916304059302"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.contactActionLinkGreen}
              >
                Chat on WhatsApp ›
              </a>
            </div>
          </div>

          <div style={styles.contactCard}>
            <div style={styles.contactIconCircleBlue}>
              <img src={EnvelopeSimple} alt="email" style={styles.contactIconImg} />
            </div>
            <div style={styles.contactInfo}>
              <strong style={styles.contactTitle}>Email Assistance</strong>
              <span style={styles.contactMeta}>For commercial billing and formal RFQs</span>
              <a href="mailto:support@brickbucket.in" style={styles.contactActionLinkBlue}>
                support@brickbucket.in
              </a>
            </div>
          </div>
        </div>

        <div style={styles.faqCard}>
          <div style={styles.faqHeader}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src={Headset} alt="headset" style={{ width: 18, height: 18, opacity: 0.85 }} />
              <h3 style={styles.faqSectionTitle}>Frequently Asked Questions</h3>
            </div>
            <span style={styles.faqSectionCount}>{FAQ_DATA.length} topics</span>
          </div>

          <div style={styles.accordionStack}>
            {FAQ_DATA.map((faq) => {
              const isOpen = openFaqId === faq.id;

              return (
                <div
                  key={faq.id}
                  style={{
                    ...styles.accordionItem,
                    borderColor: isOpen ? '#CBD5E1' : '#E2E8F0',
                  }}
                >
                  <button
                    type="button"
                    style={styles.accordionTrigger}
                    onClick={() => toggleFaq(faq.id)}
                  >
                    <span
                      style={{
                        ...styles.questionText,
                        color: isOpen ? (theme.colors.brand || theme.colors.primaryRed) : theme.colors.charcoal,
                      }}
                    >
                      {faq.question}
                    </span>
                    <img
                      src={CaretDown}
                      alt="toggle"
                      style={{
                        ...styles.caretIcon,
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      }}
                    />
                  </button>

                  {isOpen && (
                    <div style={styles.answerBox}>
                      <p style={styles.answerText}>{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #E2E8F0',
    paddingBottom: 16,
  },
  headerTitle: {
    ...theme.typography.headingLG,
    margin: 0,
    fontSize: 22,
    fontWeight: '800',
    color: theme.colors.charcoal,
  },
  headerSubtitle: {
    ...theme.typography.bodySM,
    fontSize: 13,
    color: theme.colors.concrete,
    marginTop: 4,
    display: 'block',
  },
  contactGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: 16,
  },
  contactCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #CBD5E1',
    borderRadius: 14,
    padding: '18px 20px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
    boxShadow: '0 1px 3px rgba(0,0,0,0.02)',
  },
  contactIconCircleRed: {
    width: 44,
    height: 44,
    borderRadius: 12,
    backgroundColor: '#FFF1F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  contactIconCircleGreen: {
    width: 44,
    height: 44,
    borderRadius: 12,
    backgroundColor: '#E8F5EE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  contactIconCircleBlue: {
    width: 44,
    height: 44,
    borderRadius: 12,
    backgroundColor: '#EFF6FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  contactIconImg: {
    width: 22,
    height: 22,
    objectFit: 'contain',
    display: 'block',
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    minWidth: 0,
  },
  contactTitle: {
    fontFamily: theme.typography.headingMD.fontFamily,
    fontSize: 14,
    fontWeight: '700',
    color: theme.colors.charcoal,
  },
  contactMeta: {
    fontFamily: theme.typography.bodySM.fontFamily,
    fontSize: 11.5,
    color: theme.colors.concrete,
    lineHeight: '16px',
  },
  contactActionLinkRed: {
    fontFamily: theme.typography.bodyMD.fontFamily,
    fontSize: 13,
    fontWeight: '700',
    color: theme.colors.primaryRed || '#C7061F',
    textDecoration: 'none',
    marginTop: 4,
    display: 'inline-block',
  },
  contactActionLinkGreen: {
    fontFamily: theme.typography.bodyMD.fontFamily,
    fontSize: 13,
    fontWeight: '700',
    color: '#16A34A',
    textDecoration: 'none',
    marginTop: 4,
    display: 'inline-block',
  },
  contactActionLinkBlue: {
    fontFamily: theme.typography.bodyMD.fontFamily,
    fontSize: 13,
    fontWeight: '700',
    color: '#1D4ED8',
    textDecoration: 'none',
    marginTop: 4,
    display: 'inline-block',
  },
  faqCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    border: '1px solid #CBD5E1',
    padding: '20px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  faqHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #F1F5F9',
    paddingBottom: 14,
  },
  faqSectionTitle: {
    ...theme.typography.headingMD,
    margin: 0,
    fontSize: 16,
    fontWeight: '700',
    color: theme.colors.charcoal,
  },
  faqSectionCount: {
    fontFamily: theme.typography.bodySM.fontFamily,
    fontSize: 12,
    color: theme.colors.concrete,
    backgroundColor: '#F8FAFC',
    border: '1px solid #E2E8F0',
    padding: '3px 8px',
    borderRadius: 6,
  },
  accordionStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  accordionItem: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 10,
    overflow: 'hidden',
    transition: 'border-color 0.15s ease',
  },
  accordionTrigger: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 16px',
    backgroundColor: '#FFFFFF',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    outline: 'none',
    gap: 12,
  },
  questionText: {
    fontFamily: theme.typography.bodyMD.fontFamily,
    fontSize: 13.5,
    fontWeight: '600',
    flex: 1,
    lineHeight: '18px',
    transition: 'color 0.15s ease',
  },
  caretIcon: {
    width: 14,
    height: 14,
    opacity: 0.6,
    flexShrink: 0,
    transition: 'transform 0.2s ease',
  },
  answerBox: {
    padding: '0 16px 14px 16px',
    backgroundColor: '#FFFFFF',
  },
  answerText: {
    margin: 0,
    fontFamily: theme.typography.bodySM.fontFamily,
    fontSize: 13,
    color: '#636C78',
    lineHeight: '20px',
  },
};